// extracted by mini-css-extract-plugin
module.exports = {"avatar":"ProfileAvatar-module--avatar--Me4vG","avatarImage":"ProfileAvatar-module--avatar-image--bsfpI"};